import React from 'react';
/*import '../../styles/requestConfirmed.css';*/
import '../../../../styles/uploadimage.css';
import '../../../../styles/accept-buy-request.css';
import { Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import EmailSent from './email_sent';
import ReactGA from "react-ga";

@inject('userStore', 'navigatorStore', 'authStore')
@observer
export default class forgotPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            submit: false,
            message: ""
        }

    }

    handleInputChange(event) {
        this.setState({
            email: event.target.value
        })
    }

    handleSubmitEmail() {
        var formData = new FormData();
        formData.append("email", this.state.email)
        ReactGA.pageview('/Forgot password');

        this.props.authStore.forgotPW(formData)
            .then((response) => {
                this.setState({
                    submit: true,
                    message: response.message
                })
            })

    }
    render() {

        if (this.state.submit) {
            return (
                <EmailSent message={this.state.message} heading={"email sent"} />
            )
        }
        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry" style={{ minHeight: "740px" }}>
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    Please enter your email address
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>

                            <div className="col-sm-6 UploadPaintingCard no-margin padding-35">


                                {/* <h3 className="main-label">Please enter your email address</h3> */}

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="address1">Email</label>
                                            <input className="input-text" type="email" name="email"
                                                placeholder="Your email"
                                                onChange={this.handleInputChange.bind(this)}
                                                required />
                                        </p>
                                    </div>
                                </div>

                                <p className=" mb-25 ml-15">
                                    <input type="submit" name="submit" className="masterpieces-primary-buttons btn-primary"
                                        id="Newsletter_feedback" style={{}}
                                        value="Submit" onClick={this.handleSubmitEmail.bind(this)} />
                                </p>


                            </div>
                        </div>

                    </div>
                </article>
            </div >

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/resetPassword/forgotPassword.js